import { AnyAction } from 'redux';
import T from './actionTypes';

type State = {
  isCaptchaShown: boolean;
  successUrl: string;
  keys: string;
  mountContainer?: string;
};

const initialState: State = {
  isCaptchaShown: false,
  successUrl: '',
  keys: '',
  mountContainer: '',
};

const reducer = (state: State = initialState, action: AnyAction) => {
  switch (action.type) {
    case T.SHOW_CAPTCHA: {
      const { successUrl, keys, mountContainer } = action;

      return {
        ...state,
        successUrl,
        keys,
        isCaptchaShown: true,
        mountContainer,
      };
    }

    case T.RESET_CAPTCHA: {
      return initialState;
    }

    default:
      return state;
  }
};

export default reducer;
export type SharedState = ReturnType<typeof reducer>;
